// IP-15563. Shared by the Summaries and Scopes of Work settings listings, which are the same shape:
// name, rich text, a default-for-tech flag and an edit link. One feature mounted twice with props
// rather than two near-identical copies.
export const SORTABLE_COLUMNS = ['name', 'defaultForTech'];

export const INITIAL_SORT = { field: 'name', dir: 'asc' };
